import React from 'react'
import { Link } from 'react-router-dom'

const Header = ({title, to, linkText, rightComponent}) => (
  <div className="p-d-flex p-jc-between p-mb-1 p-flex-column p-flex-md-row p-text-center p-text-md-left">
    <div className="">
      <h3>{title}</h3>
    </div>
    <div>
      { linkText && <Link to={to}><i className="pi pi-chevron-left p-pr-1 p"/>{linkText}</Link> }
      { rightComponent && rightComponent }
    </div>
  </div>
)

export default Header